import React, { Component } from "react";
import { Col, Row, Spin, Card, Modal } from "antd";
import axios from "axios";

import { API_ERRO_TYPE_CANCEL } from "./../../../config/general";
import { UIUpload } from "./../../../components";
import { customerEmpresasService } from "../../../redux/services";

class Atestados extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      empresas: [],
      customer_id: null,
    };

    this._axiosCancelToken = null;
    this.uploadsRefs = {};
    this._lastFiles = {};
  }

  init = (customer) => {
    this.setState({
      isLoading: true,
      customer_id: customer.uuid,
    });

    this.fetchEmpresas(customer.uuid);
  };

  fetchEmpresas = (customer_id) => {
    if (this._axiosCancelToken) {
      this._axiosCancelToken.cancel("Only one request allowed at a time.");
    }

    this._axiosCancelToken = axios.CancelToken.source();

    customerEmpresasService
      .getEmpresas({
        client_id: customer_id,
        cancelToken: this._axiosCancelToken.token,
      })
      .then((response) => {
        const empresas = response.data.data || [];

        this.setState(
          {
            isLoading: false,
            empresas,
          },
          () => {
            this.loadAllExistingFiles();
          }
        );
      })
      .catch((data) => {
        if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

        this.setState({ isLoading: false });

        Modal.error({
          title: "Ocorreu um erro!",
          content: String(data),
        });
      });
  };

  checkUploadChanges = (empresa, tipo) => {
    const ref = this.uploadsRefs[`${tipo}_${empresa.id}`];
    if (!ref) return;

    const currentFiles = ref.getFiles()?.files || [];

    const key = `${tipo}_${empresa.id}`;
    const previousFiles = this._lastFiles[key] || [];

    if (currentFiles.length !== previousFiles.length) {
      this._lastFiles[key] = [...currentFiles];

      if (currentFiles.length > 0) {
        const file = currentFiles[0];

        if (!file.uuid) {
          this.handleUploadChange(
            this.state.customer_id,
            empresa.id,
            tipo,
            file
          );
        }
      }
    }
  };

  handleUploadChange = async (cliente_id, empresa_id, tipo, file) => {
    try {
      await customerEmpresasService.uploadArquivo({
        cliente_id,
        empresa_id,
        tipo,
        file,
      });
    } catch (error) {
      console.error("Erro no upload", error);
    }
  };

  getMimeType = (url) => {
    const ext = url.split(".").pop().toLowerCase();

    switch (ext) {
      case "jpg":
      case "jpeg":
      case "png":
        return "image/" + ext.replace("jpg", "jpeg");
      case "pdf":
        return "application/pdf";
      case "doc":
        return "application/msword";
      default:
        return "application/octet-stream";
    }
  };

  loadExistingFiles = (empresa) => {
    // REP-P
    if (empresa.rep_p_file) {
      const ref = this.uploadsRefs[`rep_p_${empresa.id}`];
      if (ref) {
        ref.setFiles([
          {
            url: empresa.rep_p_file,
            uuid: null,
            type: this.getMimeType(empresa.rep_p_file),
          },
        ]);
      }
    }

    // PTRP
    if (empresa.ptrp_file) {
      const ref = this.uploadsRefs[`ptrp_${empresa.id}`];
      if (ref) {
        ref.setFiles([
          {
            url: empresa.ptrp_file,
            uuid: null,
            type: this.getMimeType(empresa.ptrp_file),
          },
        ]);
      }
    }
  };

  loadAllExistingFiles = () => {
    this.state.empresas.forEach((empresa) => {
      this.loadExistingFiles(empresa);
    });
  };

  getData = () => {
    const atestados = [];

    this.state.empresas.forEach((empresa) => {
      const repPFiles = this.uploadsRefs[`rep_p_${empresa.id}`]?.getFiles();
      const ptrpFiles = this.uploadsRefs[`ptrp_${empresa.id}`]?.getFiles();

      if (repPFiles || ptrpFiles) {
        const item = {
          empresa_id: empresa.id,
        };

        if (repPFiles && repPFiles.files && repPFiles.files.length > 0) {
          if (!repPFiles.files[0].uuid) {
            item.rep_p = repPFiles.files[0];
          }
        }

        if (ptrpFiles && ptrpFiles.files && ptrpFiles.files.length > 0) {
          if (!ptrpFiles.files[0].uuid) {
            item.ptrp = ptrpFiles.files[0];
          }
        }

        if (item.rep_p || item.ptrp) {
          atestados.push(item);
        }
      }
    });

    return atestados;
  };

  render() {
    const { isLoading, empresas } = this.state;

    if (isLoading) {
      return (
        <div style={{ textAlign: "center", padding: "50px 0" }}>
          <Spin
            indicator={
              <i
                className="fad fa-spinner-third fa-spin"
                style={{ fontSize: 24 }}
              />
            }
          />
        </div>
      );
    }

    if (!empresas || empresas.length === 0) {
      return (
        <div style={{ textAlign: "center", padding: "50px 0", color: "#999" }}>
          <i
            className="fal fa-building"
            style={{ fontSize: 48, marginBottom: 16, display: "block" }}
          />
          <p>Nenhuma empresa encontrada para este cliente.</p>
        </div>
      );
    }

    empresas.forEach((empresa) => {
      this.checkUploadChanges(empresa, "rep_p");
      this.checkUploadChanges(empresa, "ptrp");
    });

    return (
      <div>
        {empresas.map((empresa, index) => (
          <Card
            key={empresa.id}
            title={empresa.nome}
            style={{ marginBottom: 16 }}
            headStyle={{ backgroundColor: "#f5f5f5" }}
          >
            <Row gutter={16}>
              <Col xs={24} sm={12}>
                <div style={{ marginBottom: 8 }}>
                  <label
                    style={{
                      fontWeight: 500,
                      marginBottom: 8,
                      display: "block",
                    }}
                  >
                    REP-P
                  </label>
                  <UIUpload
                    ref={(el) => (this.uploadsRefs[`rep_p_${empresa.id}`] = el)}
                    acceptedFiles={["pdf", "doc", "jpg", "jpeg", "png"]}
                    multiple={false}
                    fi
                  />
                </div>
              </Col>
              <Col xs={24} sm={12}>
                <div style={{ marginBottom: 8 }}>
                  <label
                    style={{
                      fontWeight: 500,
                      marginBottom: 8,
                      display: "block",
                    }}
                  >
                    PTRP
                  </label>
                  <UIUpload
                    ref={(el) => (this.uploadsRefs[`ptrp_${empresa.id}`] = el)}
                    acceptedFiles={["pdf", "doc", "jpg", "jpeg", "png"]}
                    multiple={false}
                  />
                </div>
              </Col>
            </Row>
          </Card>
        ))}
      </div>
    );
  }
}

export default Atestados;
